import { handleNetworkError } from "@/Components/Uitoast/globalToastHandler";
import useGlobalRoutesHandler from "@/hooks/useGlobalHandleRouter";
import { handleGlobalPostRequest } from "@/lib/httpFunction/globalApiFunction";
import { CORE_URLS } from "@/services/URLS/CORE_URLS";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { ILoginSubmitSchema, IUserRegisterSubmitSchema } from "../auth.types";

const useAuth = () => {
  const { navigate } = useGlobalRoutesHandler();

  const [showOtpField, setShowOtpField] = useState(false);
  const [timer, setTimer] = useState(0);
  const [canResend, setCanResend] = useState(false);

  const registerUserMutation = useMutation({
    mutationFn: (data: IUserRegisterSubmitSchema) =>
      handleGlobalPostRequest({ url: CORE_URLS.REGISTER_USER, data }),
    onError: (error) => {
      handleNetworkError({ error });
    },
  });

  const loginUserMutation = useMutation({
    mutationFn: (data: ILoginSubmitSchema) =>
      handleGlobalPostRequest({ url: CORE_URLS.LOGIN, data }),
    onError: (error) => {
      handleNetworkError({ error });
    },
  });

  const verifyOtpMutation = useMutation({
    mutationFn: (data: any) =>
      handleGlobalPostRequest({ url: CORE_URLS.VERIFY_OTP, data }),
    onError: (error) => {
      handleNetworkError({ error });
    },
  });

  const forgotPasswordMutation = useMutation({
    mutationFn: (data: any) =>
      handleGlobalPostRequest({ url: CORE_URLS.LOGIN, data }),
    onError: (error) => {
      handleNetworkError({ error });
    },
  });

  return {
    mutations: {
      registerUserMutation,
      loginUserMutation,
      forgotPasswordMutation,
      verifyOtpMutation,
    },
    states: {
      showOtpField,
      setShowOtpField,
      timer,
      setTimer,
      canResend,
      setCanResend,
    },
    routing: {
      navigate,
    },
  };
};

export default useAuth;
